import { svgToCssUrl } from 'src/utils/svgToCssUrl';
import theme, { rtlFlip } from 'src/utils/theme';
import styled, { css } from 'styled-components';
import { remToPx, stripUnit } from 'src/utils/themeUtils';
import Stack from 'src/components/Stack';
import LoadingSkeletonCard from 'src/components/LoadingSkeletonCard';
import icons from 'src/components/Icon/icons';
import { SvgHelperWrapper } from '../Icon/iconHelper';

const { stars: Stars, starsCompleted: StarsCompleted } = icons;

const stars = (isCompleted?: boolean) =>
  isCompleted
    ? `${svgToCssUrl(<SvgHelperWrapper Svg={StarsCompleted} />)}`
    : `${svgToCssUrl(<SvgHelperWrapper Svg={Stars} />)}`;

export const ProgressCard = styled.button<{
  $isPremium?: boolean;
  $isCompleted?: boolean;
  $isWide?: boolean;
}>(({ theme, $isPremium, $isCompleted, $isWide }) => {
  return css`
    background-color: ${theme.co.neutral98};
    width: 100%;
    min-width: ${theme.sz.s44};
    height: ${theme.sz.s32};
    padding: ${theme.sz.s3} 0 ${theme.sz.s3} ${theme.sz.s3};
    border: solid ${$isCompleted ? theme.co.primary60 : theme.co.primary30};
    border-width: 0 0 ${theme.bo.thickWidth} 0;
    border-radius: ${theme.bo.mediumSmall};
    cursor: pointer;
    position: relative;

    // min width that fits 2 cards with space
    @media (max-width: 395px) {
      height: ${$isWide && theme.sz.s20};
    }

    ${
      $isPremium &&
      css`
        background-color: ${$isCompleted ? theme.co.primary98 : theme.co.primary90};
        background-image: ${stars($isCompleted)};
        background-repeat: no-repeat;
        background-position: right ${theme.sz.s5} top ${theme.sz.s1};
      `
    }

    &:hover {
      background-color: ${theme.co.neutral95};
      border-color: ${$isCompleted ? theme.co.primary60 : theme.co.primary30};

      ${
        $isPremium &&
        css`
          background-color: ${$isCompleted ? theme.co.primary90 : theme.co.primary60};
          border-color: ${$isCompleted ? theme.co.primary98 : theme.co.primary90};
        `
      }
    }
  `;
});

export const ContentWrapper = styled(Stack)(
  () => css`
    position: relative;
  `,
);

export const Photo = styled.img<{ $isCompleted?: boolean }>(
  ({ $isCompleted }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: ${
        /* istanbul ignore next: manually tested aesthetically */ theme.rtl ? 'left' : 'right'
      }
      top;
    transform: scaleX(${rtlFlip(theme)});
    opacity: ${$isCompleted && 0.5};
    z-index: 0;
    pointer-events: none;
  `,
);

export const Title = styled.p(
  ({ theme }) => css`
    font-size: ${theme.DEPRECATED_ty.small};
    font-weight: ${theme.DEPRECATED_ty.semiBold};
    text-align: left;
    position: absolute;
    bottom: ${theme.sz.s3};
    margin: 0;
    padding-right: ${theme.sz.s12};
    color: ${theme.co.neutral0};
  `,
);

export const IconWrapper = styled.div(
  ({ theme }) => css`
    font-size: ${theme.sz.s8};
    position: absolute;
    top: ${theme.sz.s3};
    left: ${theme.sz.s3};
    z-index: 1;

    svg {
      path {
        fill: url(#a) ${theme.co.primary20}; // fallback for when svg gradient isn't supported
      }
    }
  `,
);

const loadingSkeletonWidth = theme.sz.s44;

export const loadingSkeletonWidthInPx = Number(stripUnit(remToPx(loadingSkeletonWidth)));

export const LoadingSkeleton = styled(LoadingSkeletonCard)<{
  $isWide?: boolean;
}>(
  ({ theme, $isWide }) => css`
    min-width: ${loadingSkeletonWidth};
    width: 100%;
    min-height: ${theme.sz.s28};

    // min width that fits 2 cards with space
    @media (max-width: 395px) {
      min-height: ${$isWide && theme.sz.s20};
    }
  `,
);
